import * as React from 'react';
import Form from '../../Form';
import { FormControl } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import FormHelperText from '@mui/material/FormHelperText';
import './ReservationSetupCurrency.css';
import { FeeCurrency } from '../../../CommonInterfaces';
import { getCurrencySymbol } from '../../../lib/currencyHelpers';

interface ReservationMinimumsProps {
  shipperMinimum: string;
  shipperMinimumKey: string;
  warehouseMinimum: string;
  warehouseMinimumKey: string;
  feeCurrency: FeeCurrency;
  onFieldChange(event);
}

class ReservationMinimums extends Form<ReservationMinimumsProps, any> {
  public render() {
    const {
      shipperMinimum,
      shipperMinimumKey,
      warehouseMinimum,
      warehouseMinimumKey,
      feeCurrency,
      onFieldChange,
      formErrors,
      disableForm,
    } = this.props;
    const currencySymbol = getCurrencySymbol(feeCurrency);
    return (
      <fieldset>
        <legend>Monthly Minimums</legend>
        <FormControl variant="standard" disabled={disableForm}>
          <InputLabel htmlFor="monthly-minimum">Shipper Minimum *</InputLabel>
          <Input
            id="monthly-minimum"
            name={shipperMinimumKey}
            value={shipperMinimum}
            onChange={onFieldChange}
            type="number"
            inputProps={{ min: 0, step: 1 }}
            required
          />
          <FormHelperText>i.e. 100</FormHelperText>
          <span className="currency-sign">{currencySymbol}</span>
          {formErrors.monthly_minimum && <FormHelperText error={true}>{formErrors.monthly_minimum}</FormHelperText>}
        </FormControl>
        <FormControl variant="standard" disabled={disableForm}>
          <InputLabel htmlFor="monthly-warehouse-minimum">Warehouse Minimum *</InputLabel>
          <Input
            id="monthly-warehouse-minimum"
            name={warehouseMinimumKey}
            value={warehouseMinimum}
            onChange={onFieldChange}
            type="number"
            inputProps={{ min: 0, step: 1 }}
            required
          />
          <FormHelperText>i.e. 100</FormHelperText>
          <span className="currency-sign">{currencySymbol}</span>
          {formErrors.monthly_warehouse_minimum && (
            <FormHelperText error={true}>{formErrors.monthly_warehouse_minimum}</FormHelperText>
          )}
        </FormControl>
      </fieldset>
    );
  }
}

export default ReservationMinimums;
